"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SmInputToken = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const Icon_1 = require("../Icon");
const SmInputToken = (_a) => {
    var { invalid = false, disabled = false, min = 0, max = 9, maxLength = 1, inputMode = 'numeric', type = 'number', length = 4, label = 'token', value, message, onChange } = _a, props = __rest(_a, ["invalid", "disabled", "min", "max", "maxLength", "inputMode", "type", "length", "label", "value", "message", "onChange"]);
    const initializeValue = () => {
        if (value) {
            return value
                .split('')
                .reduce((array, currentvalue, index) => (Object.assign(Object.assign({}, array), { [index]: currentvalue })), {});
        }
        return Array(length)
            .fill('')
            .reduce((array, currentvalue, index) => (Object.assign(Object.assign({}, array), { [index]: currentvalue })), {});
    };
    const [auxValue, setAuxValue] = react_1.default.useState(initializeValue);
    const inputClassname = (0, classnames_1.default)({ '-invalid': invalid });
    const listitemRef = react_1.default.useRef([]);
    react_1.default.useMemo(() => {
        if (value === undefined || value === '') {
            setAuxValue({});
            return;
        }
        if (!Number.isNaN(parseInt(value, 10))) {
            const updatedValue = value
                .split('')
                .reduce((array, currentvalue, index) => (Object.assign(Object.assign({}, array), { [index]: currentvalue })), {});
            setAuxValue(updatedValue);
        }
    }, [value]);
    const inputs = react_1.default.useMemo(() => {
        return Array.from(Array(length), (_, i) => {
            return (react_1.default.createElement("input", Object.assign({ key: i, type: type, inputMode: inputMode, min: min, max: max, maxLength: maxLength, disabled: disabled, ref: (el) => {
                    listitemRef.current[i] = el;
                }, "aria-invalid": invalid, className: inputClassname, "aria-label": `${label}, ${i + 1} de ${length}`, value: auxValue[i] || '', onChange: (e) => {
                    var _a;
                    const nativeEvent = e.nativeEvent;
                    if (auxValue[i] === undefined ||
                        auxValue[i].length < 1 ||
                        nativeEvent.data === null) {
                        const updatedValue = Object.assign(Object.assign({}, auxValue), { [i]: e.target.value });
                        setAuxValue(updatedValue);
                        onChange === null || onChange === void 0 ? void 0 : onChange(Object.values(updatedValue).join(''), e);
                        if (e.target.value) {
                            const nextInput = (_a = listitemRef.current[i]) === null || _a === void 0 ? void 0 : _a.nextSibling;
                            if (length !== i + 1) {
                                nextInput.focus();
                            }
                        }
                    }
                } }, props)));
        });
    }, [
        auxValue,
        inputClassname,
        type,
        inputMode,
        min,
        max,
        maxLength,
        disabled,
        invalid,
        value,
        length,
    ]);
    const fieldClassnames = (0, classnames_1.default)('c-field', { '-invalid': invalid });
    return (react_1.default.createElement("div", { className: fieldClassnames },
        react_1.default.createElement("div", { className: "c-token" }, inputs),
        message && (react_1.default.createElement("small", { className: "c-field__description" },
            invalid && (react_1.default.createElement(Icon_1.SmIcon, { name: "error_outline", size: "small", className: "mr-2", type: "outlined" })),
            message))));
};
exports.SmInputToken = SmInputToken;
//# sourceMappingURL=index.js.map